import { Box, Text } from 'grommet';
import React, { useState } from 'react';
import { formatMonth, getCurrentYear, getListOfMonths, getCurrentMonth } from '../../utils/dates';
import { DisplayInlineBlockBox } from '../../utils/styled';
import {
    IconChevronRight as IconArrowRight,
    IconChevronLeft as IconArrowLeft,
    IconCalendar
} from '@tabler/icons-react';
import Icon from '../Icon';
import Button from '../Button';
import { snakeCase } from '../../utils/string';
import DropButton from '../DropButton';

const MonthPicker = ({value, onChange, containerProps, returnStartDayOfMonth=true, placeholder=""}) => {
    const [openDrop, setOpenDrop] = useState(false);
    const currentYear = getCurrentYear();
    const currentMonth = getCurrentMonth();
    const nextMonth = currentMonth === 12 ? 1 : currentMonth + 1;
    const maxYear = currentYear + 10;
    const [selectedMonth, setSelectedMonth] = useState(value ? (new Date(value)).getMonth()+1 : nextMonth);  // getMonth() returns off by 1 error
    const [activeYear, setActiveYear] = useState(value ? new Date(value).getFullYear() : (currentMonth === "12" ? currentYear + 1 : currentYear)); // wraps to next year
    const monthOptions = getListOfMonths();

    return (
        <Box direction='row' fill="horizontal">
            <DropButton
                event={{section: 'month_picker', element: 'input'}}
                plain
                fill="horizontal"
                onClick={()=>{setOpenDrop(!openDrop)}}
                open={openDrop}
                dropContent={(
                    <Box pad="small" width={{max: 'small'}}>
                        <Box direction="row" align="center" justify='between' pad={'xsmall'}>
                            <Text>{activeYear}</Text>
                            <Box direction="row" align="center" gap="xsmall">
                                <Button
                                    event={{section: 'month_picker', element: 'prev_month'}} 
                                    label={(<Icon SelectedIcon={IconArrowLeft} size="xxsmall" />)}
                                    onClick={() => {
                                        setSelectedMonth();
                                        setActiveYear(Math.max(activeYear - 1, currentYear))
                                    }}
                                    disabled={activeYear === currentYear}
                                    hoverIndicator
                                />
                                <Button
                                    event={{section: 'month_picker', element: 'next_month'}} 
                                    label={(<Icon SelectedIcon={IconArrowRight} size="xxsmall" />)}
                                    onClick={() => {
                                        setSelectedMonth();
                                        setActiveYear(Math.min(activeYear + 1, maxYear))
                                    }}
                                    disabled={activeYear === maxYear}
                                    hoverIndicator
                                />
                            </Box>
                        </Box>
                        <Box>
                            <Box direction="row" align="center" justify="evenly" wrap>
                                {monthOptions.map(item => (
                                    <DisplayInlineBlockBox
                                        basis="1/3"
                                        key={item?.value}
                                        round="xxsmall"
                                        background={item?.value === selectedMonth ? 'brand' : undefined}>
                                        <Button
                                            event={{section: 'month_picker', element: 'month_option', description: snakeCase(item?.name)}} 
                                            label={(<Text weight={item?.value === selectedMonth ? 'bold' : undefined}>{item?.name}</Text>)}
                                            onClick={() => {
                                                setOpenDrop(false);
                                                setSelectedMonth(item?.value);
                                                const newDate = returnStartDayOfMonth ? new Date(activeYear, item?.value-1, 1) : new Date(activeYear, item?.value, 0);
                                                onChange && onChange({value: newDate.toString()});
                                            }}
                                            disabled={activeYear === currentYear && (item.value < (currentMonth + 1))} // do not allow user select present or prior months
                                            fill="horizontal"
                                        />
                                    </DisplayInlineBlockBox>
                                ))}
                            </Box>
                        </Box>
                    </Box>
                )}
                dropProps={{
                    width: { max: 'small' },
                    align: { top: 'bottom', right: 'right' },
                    onClickOutside: () => setOpenDrop(false)
                }}
                label={
                    (
                        <Box direction="row" justify="between" pad="9px" {...containerProps}>
                            <Text {...(value ? {} : {color: 'text-weak'})}>{value ? formatMonth(value) : placeholder}</Text>
                            <Icon SelectedIcon={IconCalendar} size="small" />
                        </Box>
                    )
                } />
        </Box>
    );
};

export default MonthPicker;